module.exports = __webpack_public_path__ + "assets/img/26_824.7d803adf.jpg";